
















import type { Result } from '@empathy/search-types';
import { Components, TrackClickMixin } from '@empathybroker/ebx-gluon';
import { Component, Mixins, Prop } from 'vue-property-decorator';

@Component({
  components: {
    ResultIdentifier: Components.Pure.ResultIdentifier
  }
})
export default class CdlResultEditions extends Mixins(TrackClickMixin) {
  @Prop()
  item: Result;
}
